import React from 'react'
import { Thermometer } from './Thermometer'

export default function ThermometerWithGate({ value, enabled, className, showLabel = false, note, noteClassName }: { value: number; enabled: boolean; className?: string; showLabel?: boolean; note?: string; noteClassName?: string }) {
  const v = Math.max(0, Math.min(100, Number(value || 0)))
  return (
    <div className="relative w-full">
      <div className={enabled ? '' : 'grayscale opacity-70'}>
        <Thermometer value={v} className={className} showLabel={showLabel} />
      </div>
      {!enabled && (
        <div className="pointer-events-none mt-1 w-full text-center text-xs text-foreground/60">Recurso será liberado em breve!</div>
      )}
      {enabled && note && (
        <div className={["pointer-events-none mt-1 w-full text-center text-foreground/60", noteClassName || 'text-xs'].join(' ')}>{note}</div>
      )}
    </div>
  )
}
